import { provideHttpClient } from '@angular/common/http'
import { APP_INITIALIZER, NgModule } from '@angular/core'
import { environment } from '@environments/environment'
import { provideTransloco, TranslocoModule, TranslocoService } from '@jsverse/transloco'
import { BehaviorSubject, firstValueFrom } from 'rxjs'
import { TranslocoHttpLoader } from './transloco-loader'

const isLoading$ = new BehaviorSubject<boolean>(true)
const DEFAULT_LANGUAGE = 'it'
export function preloadTranslation(transloco: TranslocoService) {
	return async () => {
		transloco.setActiveLang(DEFAULT_LANGUAGE)
		return firstValueFrom(transloco.load(DEFAULT_LANGUAGE)).then(() => {
			isLoading$.next(false) // Indichiamo che le traduzioni sono pronte
		})
	}
}

@NgModule({
	exports: [TranslocoModule],
	providers: [
		provideHttpClient(),
		provideTransloco({
			config: {
				availableLangs: ['it', 'en'],
				defaultLang: DEFAULT_LANGUAGE,
				// Remove this option if your application doesn't support changing language in runtime.
				reRenderOnLangChange: true,
				prodMode: environment.production,
			},
			loader: TranslocoHttpLoader,
		}),
		{
			provide: APP_INITIALIZER,
			multi: true,
			deps: [TranslocoService],
			useFactory: preloadTranslation,
		},
	],
})
export class TranslocoRootModule {}
